import { createSlice } from "@reduxjs/toolkit";

// Holds logged-in user context fetched from /v3/me.
// Replaces the JS-accessible cookies that used to carry userId/role/userName/email/org.
// The auth token itself is NOT in Redux — it lives in the HttpOnly cookie set by the backend.
const initialState = {
  user: null,
  isAuthenticated: false,
  loading: true,
  sessionExpired: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.loading = false;
      state.sessionExpired = false;
    },
    clearAuth: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.sessionExpired = false;
    },
    markSessionExpired: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.sessionExpired = true;
    },
    setAuthLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setAuth, clearAuth, markSessionExpired, setAuthLoading } = authSlice.actions;
export default authSlice.reducer;

export const selectUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthLoading = (state) => state.auth.loading;
export const selectSessionExpired = (state) => state.auth.sessionExpired;
export const selectUserId = (state) => state.auth.user?.userId;
export const selectRole = (state) => state.auth.user?.role;
export const selectFirstName = (state) => state.auth.user?.firstname;
export const selectLastName = (state) => state.auth.user?.lastname;
export const selectFullName = (state) => {
  const u = state.auth.user;
  if (!u) return "";
  if (u.firstname || u.lastname) return `${u.firstname || ""} ${u.lastname || ""}`.trim();
  return u.username || "";
};
export const selectEmail = (state) => state.auth.user?.username;
export const selectOrgId = (state) => state.auth.user?.orgId;
export const selectOrgName = (state) => state.auth.user?.orgName;
